import React, { useState, useEffect } from "react";
import { BaseUrlFiles } from "../../Constant/Config";
import axios from "axios";
import Loading from "../Error Modal/Loading";
import { MDBDataTable } from "mdbreact";
import CloseIcon from "@material-ui/icons/Close";
import BarChart from "@material-ui/icons/BarChart";
import No_Image from "../../assets/img/No_Image.png";
import Modal from "react-modal";
import Header from "../Header/Header";
import { useHistory } from "react-router";
import { BaseUrl } from "../../Constant/Config";
import ErrorModal from "../Error Modal/ErrorModal";
import {Link ,Redirect} from "react-router-dom";

export default function User() {
  const history = useHistory();
  // state
  const [word, setWord] = useState();
  const [userList, setUserList] = useState();
  const [loading, setLoading] = useState(false);
  const [showWord, setShowWord] = useState(false);
  const [type, setType] = useState("");
  const [badge, setBadge] = useState();
  const [badgeData, setBadgeData] = useState();
  const [textError, setTextModal] = useState("");
  const [errorHandler, setErrorHandler] = useState(false);
  const [removeModalIsOpen, setRemoveModalIsOpen] = useState(false);
  const [id, set_id] = useState();

  function openBadge() {
    setBadge(true);
  }

  //close add modal function
  function closeBadge() {
    setBadge(false);
  }

  const BadgeStyles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: "10",
      backgroundColor: "rgba(0 0 0 / 40%)",
    },
    content: {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
      margin: "auto",
      width: "50%",
      maxHeight: "75%",
      overflow: "hidden",
      zIndex: "10",
      borderRadius: "30px",
    },
  };

  function openShowWord() {
    setShowWord(true);
  }

  //close add modal function
  function closeShowWord() {
    setShowWord(false);
  }

  const ShowStyles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: "10",
      backgroundColor: "rgba(0 0 0 / 40%)",
    },
    content: {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
      margin: "auto",
      width: "50%",
      height: "max-content",
      zIndex: "10",
      borderRadius: "30px",
    },
  };

  

  //close add modal function
  function closeRemoveModal() {
    setRemoveModalIsOpen(false);
  }
  const RemoveStyles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: "10",
      backgroundColor: "rgba(0 0 0 / 40%)",
    },
    content: {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
      margin: "auto",
      width: "400px",
      height: "220px",
      zIndex: "10",
      borderRadius: "30px",
      // animationName: 'Modal_animation',
      // animationDuration: '.6s'
    },
  };
  const userAttributes = [];
  userList &&
    userList.forEach((el) => {
      userAttributes.push({
        picture: el.picture ? (
          <img className="img_style" src={`${BaseUrlFiles}${el.picture}`} alt="" />
        ) : (
          <img className="img_style" src={No_Image} alt="" />
        ),
        name: el.name ? el.name : el.user_name,
        phoneNumber: el.phone_number ? el.phone_number : "تکمیل نشده",
        email: el.email ? el.email : "تکمیل نشده",
        operation: (
          <>
            {/* <button
                        className="btn text-success"
                    onClick={() => {
                        setInfoModal();
                        setUserData(el.picture, el.name, el.phone_number, el.meanings)
                    }}
                    >
                        ویرایش<CreateOutlinedIcon />
                    </button> */}
            <button
              className="btn text-danger"
              onClick={() => {
                setRemoveModalIsOpen(true);
                set_id(el._id);
              }}
            >
              حذف
              <CloseIcon />
            </button>

             <Link to={`userProfile?id=${el._id}`} className="btn text-primary">
              لیست گزارشات
              <BarChart />
            </Link>

          </>
        ),
      });
    });

  const data = {
    columns: [
      {
        label: "عکس",
        field: "picture",
        sort: "asc",
        width: 50,
      },
      {
        label: "نـام",
        field: "name",
        sort: "asc",
        width: 50,
      },
      {
        label: "شماره تلفن همراه",
        field: "phoneNumber",
        sort: "asc",
        width: 20,
      },
      {
        label: "ایمیل",
        field: "email",
        sort: "asc",
        width: 20,
      },
      {
        label: "عملیات",
        field: "operation",
        sort: "asc",
        width: 50,
      },
    ],
    rows: userAttributes,
  };

  const deleteWord = () => {
    setLoading(true);
    axios
      .delete(
        `${BaseUrl}/admin/user/${id}?api_token=${localStorage.getItem("token")}`
      )
      .then((res) => {
        setUserList(res.data.data.reverse());

        setLoading(false);
      })
      .catch((err) => {
        setErrorHandler(true);
        setTextModal(err.response.data.data);
        setLoading(false);
      });
  };



  useEffect(() => {
    const getuserList = () => {
      setLoading(true);
      axios
        .get(
          `${BaseUrl}/admin/userList?api_token=${localStorage.getItem("token")}`
        )
        .then((res) => {
          setUserList(res.data.data.reverse());
  
          setLoading(false);
        })
        .catch((error) =>
          error.response.data.status === 401 ? history.push("/login") : null
        );
    };
    getuserList();
  }, []);


  if(document.querySelector('.dataTables_length.bs-select label')!==null  ){
      var ShowHtml = document.querySelector('.dataTables_length.bs-select label').innerHTML.replace('Show entries','نمایش اطلاعات');
      document.querySelector('.dataTables_length.bs-select label').innerHTML = ShowHtml;
  }

  console.log(id,"idddddddddddd")
  return (
    <>
      <Header />
      <div className="container mt-5">
        <div className="User">
          <div className="col-12 mt-5 ">
            <MDBDataTable   labelRowsPerPage={'gdggfg'} paginationLabel={['قبلی', 'بعدی']}   searchLabel={'جستــجو ..'}  responsive striped bordered data={data} />
          </div>
        </div>
      </div>
      {loading && <Loading isOpen={loading} />}
      {removeModalIsOpen && (
        <Modal
          isOpen={removeModalIsOpen}
          onRequestClose={closeRemoveModal}
          style={RemoveStyles}
          closeTimeoutMS={200}
        >
          <div className="row d-flex align-items-center center px-4">
            <div>
              <CloseIcon
                fontSize="large"
                className="pointer"
                onClick={closeRemoveModal}
              />
              <span className="mr-2 text_bold">حذف مهـارت</span>
            </div>
          </div>
          <div className="row justify-content-center align-items-center text_remove_Modal mt-4">
            آیا شما قصد حذف کردن این کاربر را دارید؟
          </div>
          <div className="row d-flex justify-content-center align-items-center mt-5">
            <button
              onClick={() => {
                return (deleteWord(), closeRemoveModal());
              }}
              className="btn btn-outline-success px-5 mx-3"
            >
              بلــه
            </button>
            <button
              onClick={closeRemoveModal}
              className="btn btn-danger px-5 mx-3"
            >
              خیـر
            </button>
          </div>
        </Modal>
      )}
    
    
      {errorHandler ? (
        <ErrorModal
          isOpen={errorHandler}
          error={textError}
          close={setErrorHandler}
        />
      ) : null}
    </>
  );
}
